const TRACKING_ENABLED_FLAG = 'true';

const toNormalizedValue = (value: string | undefined): string =>
  String(value ?? '').trim().toLowerCase();

export const isTrackingEnabled = (): boolean => {
  return toNormalizedValue(import.meta.env.VITE_ENABLE_TRACKING) === TRACKING_ENABLED_FLAG;
};
